import type { CSSProperties, ReactNode } from 'react';
import { useBlobUrl } from './useBlobUrl';
import type { MediaRef } from '../../types';

interface CachedImageProps {
  // Named `mediaRef` (not `ref`) to avoid conflicting with React's
  // reserved ref-forwarding prop name.
  mediaRef: MediaRef | null | undefined;
  fallback?: ReactNode;
  style?: CSSProperties;
  alt?: string;
}

// Renders a <MediaRef> as an <img> backed by the IDB blob cache. While
// the blob loads (or if it's missing), renders `fallback` (null by
// default). Object URLs are revoked automatically on unmount.
export function CachedImage({
  mediaRef,
  fallback = null,
  style,
  alt = '',
}: CachedImageProps) {
  const url = useBlobUrl(mediaRef ?? null);
  if (!url) return <>{fallback}</>;
  return <img src={url} alt={alt} draggable={false} style={style} />;
}
